module.exports = __webpack_public_path__ + "img/inventario.e40a859c.png";